<template>
  <div class="deleted d-flex flex-column justify-content-center align-items-center">
    <div class="image-container mb-4">
      <img src="../../public/img/Consagradas_logo_login.png" class="img-fluid" />
    
    
    </div>

    <div class="row">
      <div class="col-md-4">
        <button class="btn btn-primary text-white" @click="$router.push('/terminos')">
          Términos y condiciones
        </button>
      </div>
      <div class="col-md-4">
        <button class="btn btn-primary text-white" @click="$router.push('/politicas')">
          Políticas de Privacidad
        </button>
      </div>
      <div class="col-md-4">
        <button class="btn btn-primary text-white" @click="$router.push('/cookies')">
          Políticas de Cookies
        </button>
      </div>
    </div>

  </div>
</template>

<script>
  export default {}

</script>
<style>
.deleted {
  height: 100vh;
  width: 100vw;
  background-color: #AA1E2E ;
}

.card {
  max-width: 400px;
  width: 100%;
}

.image-container {
  max-width: 300px;
  width: 100%;
}
.btn-primary {
  background-color: transparent;
  border: 2px solid #AA1E2E;
  color: #AA1E2E;
  transition: background-color 0.3s ease, border-color 0.3s ease;
}
.btn-primary:hover {
  background-color: #AA1E2E !important;
  border-color: #AA1E2E !important;
  color: white;
}
.form-control:focus {
  border-color: #AA1E2E;
  box-shadow: 0 0 0 0.2rem rgba(170, 30, 46, 0.25);
}

</style>
